// extracted by mini-css-extract-plugin
export var container = "_hg-1";
export var editor = "_hg-2";
export var resizable = "_hg-3";
export var wrapper = "_hg-0";